import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-toggle-icon',
  templateUrl: './toggle-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toggle-icon.component.scss']
})
export class ToggleIconComponent {

  @Input() icons:any;
  @Output() iconState:EventEmitter<any> = new EventEmitter<any>();
  @Input() defaultState:string='off';
  
  constructor() { }

  changedicon(event:boolean){
    this.iconState.emit(event);
  }

}
